module.exports = __webpack_public_path__ + "images/boxes/studio_13-d455595b9879a98ca7ad21d4ed57bb2d.webp";